var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87823",
    "data-name": "Group 87823",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#d0effa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M9.593,4.5H1.364A1.364,1.364,0,0,0,0,5.864v8.229a1.364,1.364,0,0,0,1.364,1.364H9.593a1.364,1.364,0,0,0,1.364-1.364V5.864A1.364,1.364,0,0,0,9.593,4.5ZM15,5.576,11.87,7.733v4.491L15,14.379a.915.915,0,0,0,1.438-.736V6.312A.915.915,0,0,0,15,5.576Z",
    transform: "translate(6.032 3.521)",
    fill: "#0daeea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallIcon);
export default __webpack_public_path__ + "static/media/video_call_icon.ba29cd05.svg";
export { ForwardRef as ReactComponent };